import React, { useReducer, useEffect, useCallback, useMemo } from 'react';

import { Button, Form, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { academicProgramsService } from 'services';
import { FormSelect } from './components/FormSelect';

export const AcademicAffairViewAuditModal = ({ isOpen, toggle, auditsList, auditId }) => {
    const reducer = (state, newState) => ({ ...state, ...newState });

    const renderAuditRows = id => {
        const audit = auditsList.find(obj => obj.requestid === id);
        const retList = [];
        for (const key in audit?.changedFields) {
            retList.push(
                audit?.changedFields[key].replace(/(?!^)([A-Z])/g, ' $1') +
                    ': ' +
                    audit['new' + audit?.changedFields[key]]
            );
        }
        return retList.join(', ');
    };

    const closeBtn = (
        <button className="close" onClick={toggle}>
            &times;
        </button>
    );

    return (
        <Modal isOpen={isOpen} className="modal-dialog modal-lg">
            <ModalHeader close={closeBtn}>View Audit {auditId}</ModalHeader>
            <ModalBody>{renderAuditRows(auditId)}</ModalBody>
        </Modal>
    );
};
